import { render, staticRenderFns } from "./GoalDetails.vue?vue&type=template&id=60972586&scoped=true&lang=pug&"
import script from "./GoalDetails.vue?vue&type=script&lang=js&"
export * from "./GoalDetails.vue?vue&type=script&lang=js&"
import style0 from "./GoalDetails.vue?vue&type=style&index=0&id=60972586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60972586",
  null
  
)

export default component.exports